module.exports = __webpack_public_path__ + "img/tips13.fe079753.png";